// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopupConfirm-module__modal___12Z-h","icon":"PopupConfirm-module__icon___32Tcj","header":"PopupConfirm-module__header___2Y0MM"};